import * as S from "./styled";

export const Dot = S.DotContainer;
